import React, { useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import withSuspense from "helpers/withSuspense";
import { PageLoading } from "helpers/loading";
import OauthVerify from "./settings/emailconfig/OauthVerify";
import Login from "./login/Login";
import Logout from "./login/Logout";
import SwitchInstance from "./login/SwitchInstance";
import ForgotPassword from "./login/password/ForgotPassword";
import ResetPassword from "./login/password/ResetPassword";
import { FooterContextProvider } from "../components/footer/FooterContext";
import PlayBorder from "../components/play/PlayBorder";
import { GeolocationProvider } from "helpers/GeolocationContext";
import browserHistory from "./GoogleGa";
import "./handle401";
import { RENTAL_BOARD_URL } from "constants/AppConstants";
import { addGoogleTagManager } from "components/utils/InitiateScript";

const Layout = withSuspense(
  React.lazy(() =>
    import(
      /* webpackChunkName: "layout" */
      /* webpackPreload: true */
      /* webpackPrefetch: true */
      "../components/uis/layout/Layout"
    )
  ),
  PageLoading
);

const RentalBoardRoutes = withSuspense(
  React.lazy(() =>
    import(
      /* webpackChunkName: "rental-dashboard" */
      "./RentalBoardRoutes"
    )
  ),
  PageLoading
);

/** @type typeof import("./contracts/signature/SignatureRequested").default */
const SignatureRequested = withSuspense(
  React.lazy(() =>
    import(
      /* webpackChunkName: "contract-signature" */
      "./contracts/signature/SignatureRequested"
    )
  ),
  PageLoading
);

const PaymentScreenRequested = withSuspense(
  React.lazy(() => import("./payment/PaymentScreen")),
  PageLoading
);

const DocumentPaymentRequested = withSuspense(
  React.lazy(() =>
    import(
      /* webpackChunkName: "invoice-payment" */
      "./transactions/payment/DocumentPaymentRequested"
    )
  ),
  PageLoading
);

/** @type typeof import("./dashboard/calendar/Present").default */
const calendarPresent = withSuspense(
  React.lazy(() =>
    import(
      /* webpackChunkName: "dashboard-calendar-full-screen" */
      "./dashboard/calendar/Present"
    )
  ),
  PageLoading
);

const App = () => {
  useEffect(() => {
    addGoogleTagManager();
  }, []);

  return (
    <FooterContextProvider>
      <Router history={browserHistory}>
        <PlayBorder />
        <GeolocationProvider>
          <Switch>
            <Route path="/forgetpassword" component={ForgotPassword} />
            <Route path="/oauth/verify" component={OauthVerify} />
            <Route path="/fg/:id" component={ResetPassword} />
            <Route
              exact
              path={["/", "/company/:companyId", "/mobile/:token", "/verify"]}
              component={Login}
            />
            <Route path="/logout" component={Logout} />
            <Route path="/instance/:id" component={SwitchInstance} />
            <Route path={RENTAL_BOARD_URL} component={RentalBoardRoutes} />
            <Route path="/payment" component={PaymentScreenRequested} />
            <Route
              path={[
                "/contract_signature_requested/:id",
                "/reservation_signature_requested/:id",
                "/quote_signature_requested/:id",
                "/all-in-one-transaction_signature_requested/:id"
              ]}
              component={SignatureRequested}
            />

            <Route
              path="/payment_requested/:documentType/:paymentId"
              component={DocumentPaymentRequested}
            />
            <Route
              path="/dashboard/calendar/present"
              component={calendarPresent}
            />
            <Route component={Layout} />
          </Switch>
        </GeolocationProvider>
      </Router>
    </FooterContextProvider>
  );
};

export default App;
